// extracted by mini-css-extract-plugin
module.exports = {"item":"TechSkills_item__1qY0p","text":"TechSkills_text___LRYD"};